export abstract class BaseEntity {
    constructor() 
    {
        
    }
}

export default BaseEntity;